export const SEARCH_RETURNS_BY_ORDER_NUMBER = 'searchReturnsByOrderNumber';
